import { Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ExpressOfferModal = styled(Dialog)(({ theme }) => ({
    '& .MuiDialog-paper': {
        width: 'calc(100% - 48px)',
        maxWidth: 960,
        margin: 24,
        borderRadius: 24,
        background: '#ffffff',
        boxShadow: '0 24px 80px rgba(10, 45, 65, 0.24)',
        [theme.breakpoints.down('sm')]: {
            width: 'calc(100% - 24px)',
            margin: 12,
            borderRadius: 20,
            maxHeight: 'calc(100% - 24px)',
        },
    },
}));

export const OfferContent = styled('div')(({ theme }) => ({
    padding: '24px 40px 36px',
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: { padding: '16px 20px 24px' },
}));

export const OfferHeader = styled('div')({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
    color: '#347e3e',
    fontSize: 24,
    fontWeight: 800,
});

export const OfferHero = styled('div')(({ theme }) => ({
    display: 'grid',
    gridTemplateColumns: '1.2fr 1fr',
    alignItems: 'center',
    gap: 32,
    padding: '28px 0',
    '& img': { width: '100%', height: 'auto', display: 'block' },
    [theme.breakpoints.down('md')]: {
        gridTemplateColumns: '1fr',
        gap: 20,
        padding: '20px 0',
        '& img': {
            maxWidth: 260, maxHeight: 135, objectFit: 'contain', marginInline: 'auto',
        },
    },
}));

export const OfferTitle = styled('h2')(({ theme }) => ({
    margin: '0 0 18px',
    color: '#10384f',
    fontSize: 44,
    lineHeight: 1.15,
    fontWeight: 800,
    letterSpacing: '-0.02em',
    [theme.breakpoints.down('md')]: { fontSize: 32, marginBottom: 12 },
}));

export const SuccessHero = styled(OfferHero)(({ theme }) => ({
    '& img': {
        aspectRatio: '1.35',
        objectFit: 'cover',
        objectPosition: 'center 46%',
    },
    [theme.breakpoints.down('md')]: {
        '& img': { maxHeight: 200, objectFit: 'cover' },
    },
}));

export const OfferDescription = styled('p')(({ theme }) => ({
    margin: 0,
    color: '#405563',
    fontSize: 20,
    lineHeight: 1.65,
    [theme.breakpoints.down('md')]: { fontSize: 17 },
}));

export const OfferValidity = styled('p')({
    margin: 0,
    color: '#405563',
    fontSize: 16,
    lineHeight: 1.65,
});

export const OfferActions = styled('div')(({ theme }) => ({
    display: 'grid',
    gap: 12,
    '& .MuiButton-root': { minHeight: 54, borderRadius: 10, fontSize: 18 },
    [theme.breakpoints.down('sm')]: { '& .MuiButton-root': { fontSize: 16 } },
}));
